// extracted by mini-css-extract-plugin
export default {"screen_container":"BlogPostScreen_screen_container__Q8SgD","post_container":"BlogPostScreen_post_container__ZwC+Z"};